import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions } from "reducers/environment";
import { actions as modalActions } from "reducers/modal";

export const useGeneralDataSelectors = (setError) => {
    const dispatch = useDispatch();
    const [countryList, setCountryList] = useState([{ value: "1", label: "Argentina" }]);
    const [stateList, setStateList] = useState([{ value: "500001", label: "CABA" }]);

    const selectorsRequest = useSelector((state) => state.environment?.generalDataSelectorsRequest);
    const { status: selectorsStatus, value: selectorsValue, error: selectorsError } = selectorsRequest;

    useEffect(() => {
        // localityListRequest
        dispatch(environmentActions.getGeneralDataSelectors());
    }, []);

    useEffect(() => {
        // selectorsRequest
        if (selectorsStatus === "SUCCESS") {
            setCountryList(
                selectorsValue?.countrySelector?.reduce(
                    (newList, { id, name }) => [...newList, { value: id, label: name }],
                    [],
                ),
            );
            setStateList(
                selectorsValue?.provinceSelector?.reduce(
                    (newList, { nemotecnico, description, code }) => [
                        ...newList,
                        { value: nemotecnico, label: description, codeId: code },
                    ],
                    [],
                ),
            );
        } else if (selectorsStatus === "FAILURE") {
            setError(selectorsError);
            dispatch(modalActions.modalShow());
        }
    }, [selectorsStatus, selectorsValue, selectorsError]);

    return {
        selectorsRequest: {
            selectorsStatus,
            selectorsValue,
            selectorsError,
        },
        selectors: {
            countryList,
            stateList,
        },
    };
};

export default useGeneralDataSelectors;
